<template>
    <ModalTemplate :visible="visible">
        <div v-if="store.state.accountInfo.vipLevel == 0" class="vip0-charge">
            <img class="charge-bg" src="@/assets/images/home/tip_icon_1.png" />
            <div class="charge-contain">
                <div class="charge-content">
                    <div class="charge-msg" v-html="t('prop.35')" />
                    <div class="charge-msg-box display-column display-y-center display-s-b">
                        <span class="amount">{{ getGold(store.state.accountInfo.gold) }}</span>
                        <span class="amount-des">{{ t("prop.36") }}</span>
                    </div>
                </div>
                <div class="btn-content display-y-center display-x-center">
                    <div class="btn-2 display-y-center display-x-center" @click="onCharge(currentVipChargeNum)">{{ t("prop.37", { amount: getGold(currentVipChargeNum) }) }}</div>
                </div>
            </div>
            <img class="btn-close" src="@/assets/images/common/btn_close.png" @click="onCloseCashBackTip" />
        </div>
        <div v-else-if="store.state.accountInfo.withdrawNum == 1" class="tip-content tip-1 item-center">
            <div class="title display-y-center display-x-center">
                {{ t("common.1") }}
            </div>
            <div class="content-bg">
                <div v-html="t('prop.38')" />
                <div class="icons">
                    <VIPItem style="transform: scale(0.5);" :vip-level="store.state.accountInfo.vipLevel" />
                    <img class="vip-icon-2" src="@/assets/images/home/convert_icon.png" />
                    <VIPItem style="transform: scale(0.6);" :vip-level="store.state.accountInfo.vipLevel + 1" />
                </div>
                <div class="btn-1 display-column display-y-center display-x-center">
                    <span class="amount">{{ getGold(currentVip2ChargeNum) }} + {{ getGold(store.state.accountInfo.gold) }}</span>
                    <span class="amount-des">{{ t("prop.36") }}</span>
                </div>
            </div>
            <!-- <div class="btn-2 display-y-center display-x-center" @click="onCharge(10000)">{{ t("prop.37", { amount: getGold(10000) }) }}</div> -->
             <div class="btn-content display-y-center display-x-center">
                <div class="btn-2 display-y-center display-x-center" @click="onCharge(currentVip2ChargeNum)">{{ t("prop.37", { amount: getGold(currentVip2ChargeNum) }) }}</div>
            </div>
            <img class="btn-close" src="@/assets/images/common/btn_close.png" @click="onCloseCashBackTip" />
        </div>
    </ModalTemplate>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import ModalTemplate from '../common/ModalTemplate.vue';
import { useI18n } from 'vue-i18n';
import { getGold } from '@/utils/currencyUtils';
import { toCharge } from '@/handle/balanceHandle';
import { getSessionData } from '@/handle/sessionHandle';
import { CHANNEL_CONFIG, SESSION_STORE } from '@/config/constConfig';
import VIPItem from '../common/VIPItem.vue';
import { currentChannel, currentVip2ChargeNum, currentVipChargeNum } from '@/config/config';
import router from '@/router';
    const props = defineProps({
        visible: {
            type: Boolean,
            default: false,
        }
    });

    const store = useStore();
    const { t } = useI18n();

    /**前往商城*/
    function onCharge(amount: number) {
        store.state.isShowCashBackTip = false;
        if (currentChannel.channel == CHANNEL_CONFIG.ID) {
            router.push("deposit");
            return ;
        }
        let params = {
            gold: amount,
            chargeEvent: 0,
        }
        toCharge(params);
    }

    function onCloseCashBackTip() {
        store.state.isShowCashBackTip = false;
        let info: any = getSessionData(SESSION_STORE.ACCOUNT_INFO.key);
        if (info && info.chargeNum <= 3) {
            store.state.isShowCashBackProp = true;
        }
    }
</script>

<style lang="less" scoped>

    .vip0-charge{
        position: relative;
        width: 345rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        .charge-bg{
            width: 345rem;
        }

        .charge-contain{
            position: absolute;
            bottom: 0%;
            .charge-content{
                background: #0B151E;
                position: relative;
                width: 315rem;
                border-radius: 5rem;
                padding: 10rem;
                z-index: 2;
    
                .charge-msg{
                    font-family: Roboto;
                    font-weight: 400;
                    font-size: 14rem;
                    color: #FFFFFF;
                    text-align: center;
                    margin-bottom: 15rem;
                }
    
                .charge-msg-box{
                    background: #162A3B;
                    border-radius: 5rem;
                    padding: 5rem 0;
                    gap: 5rem;
                    font-family: Roboto;
                    font-weight: 400;
                    font-size: 10rem;
                    color: #FFFFFF80;
    
                    .amount{
                        color: #96FF66;
                        font-weight: 700;
                        font-size: 16rem;
                    }
                }
            }
        }

    }

    .btn-close{
        width: 30rem;
        position: absolute;
        top: 104%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 4;
    }

    .btn-content{
        width: 100%;
        position: relative;
        z-index: 3;
        margin: 10rem 0;
        .btn-2 {
            width: 237rem;
            height: 36rem;
            background: #FFD645;
            border-radius: 5rem;
            font-family: Roboto;
            font-weight: 500;
            font-size: 14rem;
            color: #000000;
        }
    }

    .tip-content {
        position: absolute;
        width: 345rem;
        height: auto;
        background-color: #0F1D29;
        border-radius: 5rem;
        box-sizing: border-box;
        .title {
            color: #FFF;
            font-size: 24rem;
            >span {
                margin-top: 65rem;
            }
            >img {
                width: 127rem;
                position: absolute;
                top: -50rem;
            }
            .tip-icon-1 {
                width: 166rem;
                top: -90rem;
            }
        }
    }

    &.tip-1 {
        white-space: pre-wrap;
        padding: 60rem 10rem 10rem;
        color: #FFF;
        .content-bg {
            width: 100%;
            padding: 15rem 10rem;
            box-sizing: border-box;
            background-color: #0B151E;
            border-radius: 5rem;
            text-align: center;
            margin-bottom: 10rem;
        }
        .btn-1 {
            margin-top: 20rem;
            width: 100%;
            height: 48rem;
            background-color: #162A3B;
            border-radius: 10rem;
            padding: 5rem 0;
            gap: 5rem;
            font-family: Roboto;
            font-weight: 400;
            font-size: 10rem;
            color: #FFFFFF80;
            .amount {
                color: #96FF66;
                font-weight: 700;
                font-size: 16rem;
            }
        }
        
        .title {
            width: 100%;
            height: 47rem;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #162A3B;
            border-radius: 5rem 5rem 0 0;
        }
        .icons {
            gap: 20rem;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 46rem;
            margin-top: 20rem;
            .vip-icon-2 {
                width: 46rem;
            }
            .vip1-text {
                color: rgba(255, 255, 255, .5);
            }
        }
    }

</style>